// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0640a167","265":"3ce2e7d7","273":"7c526e3f","536":"0a0eb0c9","667":"ac5cbbd3","768":"5d514b83","906":"1a93e023","965":"c64d7ada"}[chunkId] + ".chunk.js";
};